import { getGuideMediaAsset } from "./guideMediaManifest";

const GUIDE_ASSET_BASE_URL = "https://valovate.com";

function isAbsoluteUrl(value) {
  return /^([a-z]+:)?\/\//i.test(value) || value.startsWith("data:") || value.startsWith("blob:");
}

export function resolveGuideAssetUrl(value) {
  if (typeof value !== "string" || !value) {
    return value;
  }

  if (isAbsoluteUrl(value)) {
    return value;
  }

  if (!value.startsWith("/assets/")) {
    return value;
  }

  if (typeof window !== "undefined" && window.desktopAPI?.resolveGuideAssetUrl) {
    return window.desktopAPI.resolveGuideAssetUrl(value);
  }

  if (typeof window !== "undefined" && window.desktopAPI) {
    return `${GUIDE_ASSET_BASE_URL}${value}`;
  }

  // Published guide media uses Storage in development and production alike.
  // Unmapped interface assets (logos, icons, etc.) retain their public URLs.
  const remoteGuideAsset = getGuideMediaAsset(value);
  if (typeof remoteGuideAsset?.remoteUrl === "string" && remoteGuideAsset.remoteUrl) {
    return remoteGuideAsset.remoteUrl;
  }

  return value;
}
